(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["okana-about-approach"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.section-okana-about-approach').forEach((section) => {
    const items = Array.from(section.querySelectorAll('[data-okana-about-item]'));
    const images = Array.from(section.querySelectorAll('[data-okana-about-image]'));

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        const activeIndex = item.dataset.okanaAboutItem;
        items.forEach((otherItem) => {
          if (otherItem !== item) otherItem.open = false;
        });
        images.forEach((image) => {
          image.classList.toggle('is-active', image.dataset.okanaAboutImage === activeIndex);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["okana-editorial-home"] && !Shopify.designMode) return;
  try {
    
  const initializeOkanaHeroVideo = (root = document) => {
    const videos = root.querySelectorAll('.okana-editorial__video:not([data-okana-video-ready])');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    videos.forEach((video) => {
      video.dataset.okanaVideoReady = 'true';
      if (reducedMotion) return;

      const beginPlayback = () => {
        video.muted = true;
        const playback = video.play();
        if (playback) playback.catch(() => {});
      };

      if (video.readyState >= 2) beginPlayback();
      video.addEventListener('canplay', beginPlayback, { once: true });

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) beginPlayback();
          else video.pause();
        });
      }, { threshold: 0.15 });

      observer.observe(video);
      document.addEventListener('pointerdown', beginPlayback, { once: true, passive: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeOkanaHeroVideo(), { once: true });
  } else {
    initializeOkanaHeroVideo();
  }
  document.addEventListener('shopify:section:load', (event) => initializeOkanaHeroVideo(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["okana-postpartum-approach"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.section-okana-postpartum-approach').forEach((section) => {
    const items = Array.from(section.querySelectorAll('[data-okana-method-item]'));
    const images = Array.from(section.querySelectorAll('[data-okana-method-image]'));

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        const activeIndex = item.dataset.okanaMethodItem;
        items.forEach((otherItem) => {
          if (otherItem !== item) otherItem.open = false;
        });
        images.forEach((image) => {
          image.classList.toggle('is-active', image.dataset.okanaMethodImage === activeIndex);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
